import { ClerkInstanceContext, useClerkInstanceContext } from '@clerk/shared';

export const [IsomorphicClerkContext, useIsomorphicClerkContext] = [ClerkInstanceContext, useClerkInstanceContext];
